import React from "react";
import { Button, Column, Columns, Input, Modal, Section, Table } from "@allxsmith/bestax-bulma";
import ApprovalRow from "./ApprovalRow";
import axios from "axios";
import {createSetDataFreshAction} from "../../actions/dataActions";
import {addXeroVat} from "../../utils";



export default function ApprovalModal({data, show, setShow, nominalCodes, paymentTypes, onStateChange, onSave, onCancel, codeObjects, paymentObjects, trackingOptions, trackingOptionObjects, view}){

    const handleStateChange = (data) => {
        if(view === "ready_to_approve"){
            onStateChange(data, "approved")
        }
        else{
            onStateChange(data, "ready")
        }
    }

    const getTotalChargeToUsNoVat = () => {
        let total = 0;
        data.results.forEach(part => {
            total += part.cost;
        });
        return (Math.round((total + Number.EPSILON) * 100) / 100)
    }

    const getTotalChargeToUs = () => {
        let total = 0;
        data.results.forEach(part => {
            total += addXeroVat(part.cost_vat, part.cost);
        });
        return (Math.round((total + Number.EPSILON) * 100) / 100)
    }

    // TODO(bestax-migrate): `closeOnBlur` — bestax Modal background click closes when onClose is set; remove
    return (
        <Modal
            active={show}
            onClose={() => {
                onCancel();
            }}
            closeOnBlur
        >
            <Modal.Content className={"wider-modal"}>
                <Section style={{background: "white"}}>
                    <Columns isMultiline>
                        <Column>
                            <label className="label">Supplier</label>
                            <Input
                                disabled={true}
                                value={(data.results.length > 0) ? data.results[0].supplier.display_name : ""}
                            />
                        </Column>
                        <Column>
                            <label className="label">Total Part Cost (£)</label>
                            <Input
                                disabled={true}
                                value={(data.results.length > 0) ? getTotalChargeToUsNoVat() : "£0"}
                            />
                        </Column>
                        <Column>
                            <label className="label">Total Part Cost Inc. VAT (£)</label>
                            <Input
                                disabled={true}
                                value={(data.results.length > 0) ? getTotalChargeToUs() : "£0"}
                            />
                        </Column>
                    </Columns>
                    <Columns isMultiline>
                        <Column>
                            <Table isFullwidth>
                                <thead>
                                    <tr>
                                        <th>Part Name</th>
                                        <th>Cost</th>
                                        <th>Date Ordered</th>
                                        <th>Payment Type</th>
                                        <th>Nominal Code</th>
                                        <th>Invoice Number</th>
                                        <th>Tracking Category</th>
                                        <th>Invoice Date</th>
                                    </tr>
                                </thead>
                                <tbody>
                                {data.results.map((part, index) => (
                                    <ApprovalRow
                                        part={part}
                                        index={index}
                                        nominalCodes={nominalCodes}
                                        paymentTypes={paymentTypes}
                                        codeObjects={codeObjects}
                                        paymentObjects={paymentObjects}
                                        onSave={onSave}
                                        trackingOptions={trackingOptions}
                                        trackingOptionObjects={trackingOptionObjects}
                                    />
                                ))}
                                </tbody>
                            </Table>
                        </Column>
                    </Columns>
                    <Columns isMultiline>
                        <Column>
                            <Button
                                color={"info"}
                                onClick={onCancel}
                                isFullWidth
                            >
                                Cancel
                            </Button>
                        </Column>
                        <Column>
                            <Button
                                color={"success"}
                                onClick={() => handleStateChange(data.results)}
                                isFullWidth
                            >
                                {view === "ready_to_approve" ? "Approve" : "Ready to Approve"}
                            </Button>
                        </Column>
                    </Columns>
                </Section>
            </Modal.Content>
        </Modal>
    );




}